import './Diversity.css';

function Diversityy(){
    return(
        <div className="diversity-background">
          <img className="background-image"src="https://www.kindpng.com/picc/m/117-1176758_boy-student-pic-hd-hd-png-download.png"></img>
          <div className='background-color'>
            <label className='Equity-text'>Diversity, Equity,</label><br></br>
            <label className='Equity-text'>And Inclusion</label>
            <p className='all-paigraph'>Sample text. Lorem ipsum dolor sit amet,</p>
            <p className='all-paigraph'>consectetur adipiscing elit nullam nunc justo</p>
            <p className='all-paigraph'>sagittis suscipit ultrices.</p><br></br>
            <button className='learn'><a href="https://en.wikipedia.org/wiki/Diversity"className='more'>LEARN MORE</a></button>
          </div>
        </div>
    )
}

export default Diversityy;